import React from 'react'

const RevenueGrowth = () => {
  return (
    <div>RevenueGrowth</div>
  )
}

export default RevenueGrowth